import { Capacitor, registerPlugin } from '@capacitor/core';

interface AlwaysLocationPlugin {
  configureTracking(options: { apiBaseUrl: string; authToken: string; shipmentId?: number | null }): Promise<{ status: string }>;
  requestAlways(): Promise<{ status: string }>;
  checkStatus(): Promise<{ status: string; foregroundGranted: boolean; backgroundGranted: boolean }>;
  startBackgroundTracking(): Promise<{ status: string }>;
  stopBackgroundTracking(): Promise<{ status: string }>;
  openSettings(): Promise<{ status: string }>;
}

const AlwaysLocation = registerPlugin<AlwaysLocationPlugin>('AlwaysLocation');

export const alwaysLocationService = {
  async configureTrackingIfAvailable(options: { apiBaseUrl: string; authToken: string; shipmentId?: number | null }) {
    if (!Capacitor.isNativePlatform()) {
      return null;
    }

    try {
      return await AlwaysLocation.configureTracking(options);
    } catch (error) {
      console.error('Configure background tracking failed:', error);
      return null;
    }
  },

  async requestAlwaysIfAvailable() {
    if (!Capacitor.isNativePlatform()) {
      return null;
    }

    try {
      return await AlwaysLocation.requestAlways();
    } catch (error) {
      console.error('Always location permission request failed:', error);
      return null;
    }
  },

  async startBackgroundTrackingIfAvailable() {
    if (!Capacitor.isNativePlatform()) {
      return null;
    }

    try {
      return await AlwaysLocation.startBackgroundTracking();
    } catch (error) {
      console.error('Background location start failed:', error);
      return null;
    }
  },

  async stopBackgroundTrackingIfAvailable() {
    if (!Capacitor.isNativePlatform()) {
      return null;
    }

    try {
      return await AlwaysLocation.stopBackgroundTracking();
    } catch (error) {
      console.error('Background location stop failed:', error);
      return null;
    }
  },

  async checkStatusIfAvailable() {
    if (!Capacitor.isNativePlatform()) {
      return null;
    }

    try {
      return await AlwaysLocation.checkStatus();
    } catch (error) {
      console.error('Check always location permission status failed:', error);
      return null;
    }
  },

  async openSettingsIfAvailable() {
    if (!Capacitor.isNativePlatform()) {
      return null;
    }

    try {
      return await AlwaysLocation.openSettings();
    } catch (error) {
      console.error('Open app settings failed:', error);
      return null;
    }
  },
};
